import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import {
  IAbroadCountry,
  IInsured,
  IPassportData,
  IAbroadState,
} from '../types';
import { IAbroadProgram, IAbroadTerritory } from '../../interfaces/calculators';

const initialState: IAbroadState = {
  clientId: [],
  clientName: '',
  clientLastName: '',
  programId: null,
  programs: [],
  productId: 0, /// id продукта для оплаты
  territory: null,
  territories: [],
  countries: [],
  insuredCount: null,
  newInsuredCount: null,
  insureds: [],
  begin: null,
  premium: 0,
  end: null,
  coverage: null,
  coverageList: [],
  isCovid19Checked: null,
  periodOfCover: null,
  kindOfSportId: null,
  phone: '',
  code: null,
  insuredData: null,
  insuredsData: [],
  transferType: '',
  isAgent: false,
};

const abroadSlice = createSlice({
  name: 'abroad',
  initialState,
  reducers: {
    reset: () => initialState,

    firstStepData: (
      state: Draft<IAbroadState>,
      action: PayloadAction<{
        programId: number | null;
        programs: IAbroadProgram[];
        territory: number | null;
        territories: IAbroadTerritory[];
        countries: IAbroadCountry[];
        insuredCount: number | null;
        insureds: number[];
        begin: Date | string;
        end: Date | string;
        coverage: number | null;
        coverageList: number[] | null;
        periodOfCover: string | null;
        isCovid19Checked: boolean;
        kindOfSportId: number | null;
        premium: number;
        isAgent?: boolean;
      }>
    ) => {
      state.programId = action.payload.programId;
      state.programs = action.payload.programs;
      state.territory = action.payload.territory;
      state.territories = action.payload.territories;
      state.countries = action.payload.countries;
      state.insuredCount = action.payload.insuredCount;
      state.insureds = action.payload.insureds;
      state.begin = action.payload.begin;
      state.end = action.payload.end;
      state.coverage = action.payload.coverage;
      state.coverageList = action.payload.coverageList;
      state.periodOfCover = action.payload.periodOfCover;
      state.isCovid19Checked = action.payload.isCovid19Checked;
      state.kindOfSportId = action.payload.kindOfSportId;
      state.premium = action.payload.premium;
      state.isAgent = action.payload.isAgent || false;
    },

    secondStepData: (
      state: Draft<IAbroadState>,
      action: PayloadAction<{
        insuredData: IInsured;
        insuredsData: IInsured[];
      }>
    ) => {
      state.insuredData = action.payload.insuredData;
      state.insuredsData = action.payload.insuredsData;
    },

    addNewInsured: (
      state: Draft<IAbroadState>,
      action: PayloadAction<number>
    ) => {
      state.newInsuredCount = action.payload;
      state.premium =
        (state.premium / state.insuredCount!) * state.newInsuredCount!;
      state.insuredCount = state.newInsuredCount;
    },

    addClientFullName: (
      state: Draft<IAbroadState>,
      action: PayloadAction<{ clientName: string; clientLastName: string }>
    ) => {
      state.clientName = action.payload.clientName;
      state.clientLastName = action.payload.clientLastName;
    },

    addPhoneNumber: (
      state: Draft<IAbroadState>,
      action: PayloadAction<string>
    ) => {
      state.phone = action.payload;
    },

    addProductId: (
      state: Draft<IAbroadState>,
      action: PayloadAction<number>
    ) => {
      state.productId = action.payload;
    },
    addTransferType: (
      state: Draft<IAbroadState>,
      action: PayloadAction<string>
    ) => {
      state.transferType = action.payload;
    },
    addSelectedProgram: (
      state: Draft<IAbroadState>,
      action: PayloadAction<number>
    ) => {
      state.programId = action.payload;
    },
  },
});

export const {
  firstStepData,
  secondStepData,
  addNewInsured,
  addClientFullName,
  addPhoneNumber,
  addProductId,
  addTransferType,
  addSelectedProgram,
} = abroadSlice.actions;
export default abroadSlice.reducer;
